import { z as o } from "./index-DGl1HeGK.mjs";
const s = "smart-adb_context", e = "smart-login_user_details", n = o.object({
  accessToken: o.string(),
  refreshToken: o.string(),
  idToken: o.string(),
  uid: o.string(),
  organisationId: o.string().optional(),
  userId: o.string(),
  ecomAccessToken: o.string()
}), r = o.object({
  customerUserId: o.string().optional(),
  customerPreferredLang: o.string().optional(),
  customerType: o.string().optional(),
  customerUUID: o.string().optional()
});
export {
  s as a,
  n as b,
  r as c,
  e as l
};
//# sourceMappingURL=constants-DRbnCqET.mjs.map
